import { render, staticRenderFns } from "./ModalExam.vue?vue&type=template&id=6b27d952&"
import script from "./ModalExam.vue?vue&type=script&lang=js&"
export * from "./ModalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports